const stripe = Stripe("pk_test_xJNOSLhqbq9O63S6TajlCZ1t00kz2FZAvE");

import { getFunctions, httpsCallable } from "firebase/functions";
const functions = getFunctions();
const createCheckoutSessionEmbedded = httpsCallable(functions, "createCheckoutSessionEmbedded");

let clientSecret;
const priceRef = "price_1OCl2QINNpqwvvT2j9JeiKsP";
    
initialize();

function initialize() {

  createCheckoutSessionEmbedded({ priceID: priceRef }).then( async (result) => {

          console.log("objectReturnedFromFunction", result);
          console.log("objectReturnedFromFunction value", result.data.clientSecret);

          clientSecret = result.data.clientSecret;

          // console.log("font", myFont.toString());

          const checkout = await stripe.initEmbeddedCheckout({
            clientSecret,
          });
        
          // Mount Checkout
          checkout.mount('#checkout');

  });   
}